var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiperContainer"},[_c('el-carousel',{staticClass:"swiper_cont",attrs:{"trigger":"click"}},_vm._l((_vm.list),function(item,index){return _c('el-carousel-item',{key:index,staticStyle:{"height":"100%"}},[_c('img',{attrs:{"src":item.activeIcon,"alt":""}})])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-4ab97125","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/swiperCont/index.vue
// module id = null
// module chunks = 